import { render, staticRenderFns } from "./NotifyParent.vue?vue&type=template&id=0a3923a3"
import script from "./NotifyParent.vue?vue&type=script&lang=js"
export * from "./NotifyParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports